import { useEffect } from "react";
import { LoaderFunction, useLoaderData, useNavigate } from "remix";
import { getLoggedInUser } from "~/auth.server";

export const loader: LoaderFunction = async ({ request }) => {
  const user = await getLoggedInUser(request);
  return !!user;
};

export default function Index() {
  const isLoggedIn = useLoaderData();
  const navigate = useNavigate();
  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
    } else {
      navigate("/collections");
    }
  }, []);
  return <></>;
}
